import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";
import { WhiteLabelDataProvider } from "../../data-provider/white-label.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { Campaign } from "../../models/campaign.model";
import { Feature } from "../../models/feature.model";
import { Limit } from "../../models/limit.model";
import { Plan } from "../../models/plan.model";
import { PermissionCheck } from "../../shared/permission";
import { DefaultDialogs } from "../../helper/default-dialogs.helper";

let PlanDetailsContentComponent = {
    selector: "vcPlanDetailsContent",
    templateUrl:
        "/angular/components/profile/plan-details-content.component.html",
    bindings: {},
    controller: class PlanDetailsContentController {
        private $scope: any;
        private dialog: DialogUtils;
        private defaultDialogs: DefaultDialogs;
        private modelsUtils: any;
        private limitDataProvider: LimitDataProvider;
        private whiteLabelDataProvider: WhiteLabelDataProvider;
        public permissionProvider: PermissionCheck;
        public limits: Limit;
        public campaign: Campaign;
        public plan: Plan;
        public featuresEnabled: Feature[] = [];
        public featuresDisabled: Feature[] = [];
        public featureNames = [
            "TURF_CUTTING",
            "CANVASSER_TRACKING_ALLOWED",
            "GEO_CODING",
        ];
        public securityFeatureNames = ["2FA"];
        public __env: any;
        public planLoading: boolean;
        public isOrgCampaign: boolean;
        public isLeaderView: boolean;

        constructor(
            $scope: any,
            __env: any,
            DialogUtils: DialogUtils,
            DefaultDialogs: DefaultDialogs,
            PermissionCheck: PermissionCheck,
            CampaignDataProvider: CampaignDataProvider,
            SubscriptionDataProvider: SubscriptionDataProvider,
            LimitDataProvider: LimitDataProvider,
            WhiteLabelDataProvider: WhiteLabelDataProvider,
            __app_type: string,
            ModelsUtils: any
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.defaultDialogs = DefaultDialogs;
            this.modelsUtils = ModelsUtils;
            this.__env = __env;
            this.permissionProvider = PermissionCheck;
            this.campaign = CampaignDataProvider.getActiveCampaign();
            this.isOrgCampaign =
                __app_type == "USER" && this.campaign.isOrganisationCampaign();
            this.isLeaderView = __app_type == "LEADER";
            this.limitDataProvider = LimitDataProvider;
            this.limitDataProvider
                .get()
                .then((limits: Limit) => (this.limits = limits));

            this.planLoading = true;
            SubscriptionDataProvider.planInfo(this.campaign.cpid).then(
                (activePlan: object) => {
                    if (activePlan) {
                        this.plan = new Plan(activePlan);
                    }
                    this.planLoading = false;
                },
                (error: object) => {
                    this.plan = null;
                    this.planLoading = false;
                }
            );
            this.checkFeatures(this.featureNames);
            if (WhiteLabelDataProvider.hasCustomTheme()) {
                this.checkFeatures(["WHITE_LABEL"]);
            }
            _.forEach(this.securityFeatureNames, (name: string) => {
                this.permissionProvider
                    .getSecuritySettings()
                    .then((securitySettings: object) => {
                        const feature = securitySettings[name];
                        if (
                            feature.attributes &&
                            feature.attributes.owner == 1
                        ) {
                            this.featuresEnabled.push(
                                this.modelsUtils.feature(feature.attributes)
                            );
                        } else {
                            this.featuresDisabled.push(
                                this.modelsUtils.feature(feature.attributes)
                            );
                        }
                    });
            });
        }

        checkFeatures(features: string[]): void {
            _.forEach(features, (name: string) => {
                this.permissionProvider
                    .getFeature(name)
                    .then((featurePermission: any) => {
                        if (
                            featurePermission.attributes &&
                            featurePermission.attributes.owner == 1
                        ) {
                            this.featuresEnabled.push(
                                this.modelsUtils.feature(
                                    featurePermission.attributes
                                )
                            );
                        } else {
                            this.featuresDisabled.push(
                                this.modelsUtils.feature(
                                    featurePermission.attributes
                                )
                            );
                        }
                    });
            });
        }

        getIcon(index: string): string {
            switch (index) {
                case "TURF_CUTTING":
                    return "crop";
                case "CANVASSER_TRACKING_ALLOWED":
                    return "my_location";
                case "2FA":
                    return "lock";
                case "GEO_CODING":
                    return "my_location";
                case "WHITE_LABEL":
                    return "sell";
                default:
                    return "";
            }
        }

        checkExtras(): boolean {
            return this.limits.extracustomfields > 0;
        }

        openChangePlanDialog(ev: any): void {
            if (this.permissionProvider.hasStripeSubscription) {
                this.dialog.show({
                    component: "vc-upgrade-plan-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        conversionType: "change",
                    },
                    forceFullscreen: true,
                    size: "xx-large",
                    style: "background: #f6f6f6",
                });
            } else {
                this.defaultDialogs.contactSupport(
                    "Upgrade subscription",
                    "creating additional accounts",
                    ev
                );
            }
        }
    },
};

angular
    .module("profile")
    .component(
        PlanDetailsContentComponent.selector,
        PlanDetailsContentComponent
    );
